export const defaultStorageItems = [
  "accessTokens",
  "selectedDateTime",
  "selectedDateTimeNow",
  "selectedUnits",
  "phoneNumber",
  "email",
  "firstName",
  "lastName",
  "prospectId",
  "prospectVerificationId",
  "smsSent",
  "phoneVerified",
  "source",
  "tourFeedback",
];
export async function clearStorage(items = defaultStorageItems) {
  items.forEach((item) => localStorage.removeItem(item));
}

export function clearStorageStayLoggedIn() {
  // Don't clear accessTokens, so that the prospect can schedule another
  // tour without having to re-verify their phone with another One Time Password
  const items = defaultStorageItems.filter((i) => i !== "accessTokens");

  return clearStorage(items);
}
